import React from "react"
import styled from "styled-components"

import About from "./about"
import Contact from "./contact"
import Nav from "./nav"

const StyledBotbar = styled.div`
    background-color: black;
    display: flex;
    padding: 24px 16px;
    flex-direction: column;


    ${props => props.theme.responsive.mobile} {
        flex-direction: row;
        padding: 40px 30px;
    }
`
const RightWrapper = styled.div`
    display: flex;
    flex: 1;
    justify-content: space-between;
    line-height: 1.4rem;
    margin-top: 30px;
    ${props => props.theme.responsive.mobile} {
        margin-top: 0px;
        justify-content: flex-end;
    }
`

export default function Botbar({...props}) {
    return (
        <StyledBotbar>
            <About/>
            <RightWrapper>
                <Nav/>
                <Contact/>
            </RightWrapper>
        </StyledBotbar>
    )
}